module.exports = "video"